import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

export const Root = styled.div`
  position: relative;
`

export const TextBox = styled.div`
  position: absolute;
  margin-top: 2px;
  left: -30px;
  right: -30px;
  text-align: center;
  justify-content: center;
  max-height: 0px;
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 60;
  ${Root}:hover & {
    display: flex;
    opacity: 1;
    max-height: 500px;
    transition-delay: 0.5s;
  }
`

export const TextTitle = styled.div`
  color: ${C.DARKER_WHITE};
  padding: 6px 10px;
  background-color: ${C.DARKEST_GRAY};
  text-align: center;
  border-radius: 4px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  white-space: pre-line;
`